import React from 'react';
import PropTypes from 'prop-types';
import {
    Page,
    Text,
    View,
    StyleSheet,
} from "@react-pdf/renderer";
import moment from "moment-timezone";
import { displayTimeWithSecondsFormat } from './../../../utils/staticData';

const defaultClasses = StyleSheet.create({
    cellWidth: {
        width: "20%",
        margin: "auto"
    }
});

const ZoneTable = props => {
    const { classes = defaultClasses, zones, title } = props;

    const drawTable = data => {
        let i = 0;
        return data.map(row => {
            return (
                <View
                    key={i++}
                    style={classes.row}
                    break={i%20 === 0}
                >
                    <View style={[classes.cell, defaultClasses.cellWidth]}>
                        <Text style={classes.textPrimary}>
                            {moment.unix(row.data_od).format("DD/MM/YYYY \n HH:mm:ss")}
                        </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth]}>
                        <Text style={classes.textPrimary}>
                            {moment.unix(row.data_do).format("DD/MM/YYYY \n HH:mm:ss")}
                        </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth]} wrap>
                        <Text style={classes.textPrimary}>
                            {row.km_poza_rejonem}&nbsp;km
                        </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth]} wrap>
                        <Text style={classes.textPrimary}>
                            {moment.unix(row.czas_poza_rejonem).format(displayTimeWithSecondsFormat)}
                        </Text>
                    </View>
                </View>
            );
        });
    };

    return (
        <Page
            style={classes.page}
            orientation="portrait"
        >
            <View style={classes.title}>
                <Text style={classes.textHeader}>
                    {title}
                </Text>
            </View>
            <View style={classes.table}>
                <View style={[classes.row, classes.headerCell]}>
                    <View style={[classes.cell, defaultClasses.cellWidth, classes.headerCell]}>
                        <Text style={classes.textPrimary}>
                            Data od:
                        </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth, classes.headerCell]}>
                        <Text style={classes.textPrimary}>
                            Data do:
                        </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth, classes.headerCell]}>
                        <Text style={classes.textPrimary}>
                            Ilość kilometrów:
                        </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth, classes.headerCell]}>
                        <Text style={classes.textPrimary}>
                            Czas poza rejonem:
                        </Text>
                    </View>
                </View>
                <View>
                    {drawTable(zones)}
                </View>
            </View>
        </Page>
    );
};

ZoneTable.propTypes = {
    classes: PropTypes.object,
    zones: PropTypes.array,
    title: PropTypes.string
};

export default ZoneTable;
